import {
    UPDATE_PROMOCODE_GET_SUCCESS,
    UPDATE_PROMOCODE_GET_FAILURE,
    UPDATE_PROMOCODE_GET_REQUEST,
    UPDATE_PROMOCODE_GET_RESET
} from "../actions/editPromoCode";


const setUpdatePromoCode = (state = { update: false }, action) => {
    switch (action.type) {
        case UPDATE_PROMOCODE_GET_SUCCESS:
            return Object.assign({}, action);
        case UPDATE_PROMOCODE_GET_FAILURE:
            return Object.assign({}, action);
        case UPDATE_PROMOCODE_GET_REQUEST:
            return Object.assign({}, action);
        case UPDATE_PROMOCODE_GET_RESET:
            return Object.assign({}, action);
        default:
            return state;
    }
};
export {
    setUpdatePromoCode,

};